import { render, staticRenderFns } from "./LearningDetails.vue?vue&type=template&id=2ac93a88&scoped=true&"
import script from "./LearningDetails.vue?vue&type=script&lang=js&"
export * from "./LearningDetails.vue?vue&type=script&lang=js&"
import style0 from "./LearningDetails.vue?vue&type=style&index=0&id=2ac93a88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac93a88",
  null
  
)

export default component.exports